// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ApplicationEnvironment } from './app-environment'
import { IEnvironment } from './environment.interface'

export const environment: IEnvironment = {
	appEnvironment: ApplicationEnvironment.RC,
	production: false,
	targetOrigin: 'https://myembrace-rc.embracepetinsurance.com',
	allowedOrigins: ['https://myembrace-rc.embracepetinsurance.com'],
	endpoint: 'https://epimyembraceorchestrator-np.azurewebsites.net/api',
	cdnStyleLink: 'https://epiassets.azureedge.net/assets-rc/styles/palette.css',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
